import { SSO_DOMAINS, SSO_APP_ID, DOMAINS, STAGES } from '@worktracker/shared';

function getSsoHost(): string {
  const host = globalThis.location?.hostname ?? '';
  if (host === DOMAINS[STAGES.PRODUCTION]) {
    return SSO_DOMAINS[STAGES.PRODUCTION];
  }
  return SSO_DOMAINS[STAGES.STAGING];
}

export function getSsoLoginUrl(): string {
  const ssoHost = getSsoHost();
  const redirectUrl = encodeURIComponent(`${globalThis.location?.origin ?? ''}/dashboard`);
  return `https://${ssoHost}/login?app=${SSO_APP_ID}&redirect=${redirectUrl}`;
}

export function getSsoLogoutUrl(): string {
  const ssoHost = getSsoHost();
  const redirectUrl = encodeURIComponent(`${globalThis.location?.origin ?? ''}/login`);
  return `https://${ssoHost}/api/auth/logout?redirect=${redirectUrl}`;
}
